import { Reveal, Eyebrow, MaskLines } from "../site/Reveal";

const STEPS = [
  ["Diagnose", "A structured gap assessment of your registration, operations and records against current SEBI, exchange and depository requirements."],
  ["Document", "Policies, procedures, agreements and registers drafted or refreshed — written to be followed, not filed away."],
  ["Implement", "A compliance calendar with owners and evidence trails, plus training so your team can run it day to day."],
  ["Inspect-ready", "Periodic audits, certifications and on-ground support when the exchange, depository or SEBI comes calling."],
];

export const Approach = () => (
  <section data-testid="approach-section" className="relative bg-paper-2 text-ink py-24 sm:py-32 overflow-hidden">
    <div className="relative mx-auto max-w-[1400px] px-5 sm:px-8 lg:px-12 grid lg:grid-cols-12 gap-14">
      <div className="lg:col-span-5 lg:sticky lg:top-32 self-start">
        <Eyebrow>The method</Eyebrow>
        <h2 className="mt-6 font-display font-extrabold tracking-[-0.035em] leading-[0.95] text-4xl sm:text-6xl">
          <MaskLines inView lines={["From circular", <>to <span className="font-serif-i text-[var(--brass-deep)]">certainty.</span></>]} />
        </h2>
        <Reveal delay={0.2}>
          <p className="mt-8 max-w-md text-ink/70 leading-relaxed">
            Regulations change by circular. Our four-step engagement keeps your compliance function a step ahead, not a step behind.
          </p>
        </Reveal>
      </div>
      <ol className="lg:col-span-7 lg:col-start-6 border-t border-ink/15">
        {STEPS.map(([t, d], i) => (
          <Reveal as="li" key={t} delay={i * 0.06} className="group grid grid-cols-[auto_1fr] gap-6 sm:gap-10 py-9 sm:py-12 border-b border-ink/15">
            <span className="font-mono-x text-sm text-[var(--brass-deep)] pt-2">0{i + 1}</span>
            <div>
              <h3 data-testid={`approach-step-${i + 1}`} className="font-display font-bold text-3xl sm:text-5xl tracking-tight transition-transform duration-500 group-hover:translate-x-2">{t}</h3>
              <p className="mt-4 text-ink/70 leading-relaxed max-w-lg">{d}</p>
            </div>
          </Reveal>
        ))}
      </ol>
    </div>
  </section>
);
